import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';

import { SIGN_IN } from 'config/url';
import { confirmUser } from 'actions';
import useActions from 'hooks/useActions';
import PublicPage from 'components/PublicPage';


const Confirmation = ({navbarProps}) => {
  const [loading, setLoading] = useState(true);
  const [confirmed, setConfirmed] = useState(false);
  const { token } = useParams();
  const dispatchConfirm = useActions(confirmUser);
  const onSuccess = () => {
    setConfirmed(true);
  }
  useEffect(() => {
    dispatchConfirm({token}, {onSuccess});
    setLoading(false);
  }, [token]);

  return (
  <PublicPage navbarProps={navbarProps}>
    <div className="container py-6">
      <div className="box my-6">
        <div className="content">
          {loading &&
            <p>Confirmation en cours...</p>
          }
          {!loading && confirmed &&
            <>
            <p>Votre compte est confirmé</p>
            <p>Vous pouvez à présent vous connecter</p>
            <div className="has-text-centered mt-5">
              <Link to={SIGN_IN}>
                Se connecter ?
              </Link>
            </div>
            </>
          }
          {!loading && !confirmed &&
            <p>Ce lien a déjà été utilisé</p>
          }
        </div>
      </div>
    </div>
  </PublicPage>
  )
}

export default Confirmation;